export function debounce(func: Function, timeout: number = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
export function throttle(func: Function, timeout: number = 300) {
    let timer;
    return (...args) => {
        if (!timer) {
            func.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(() => {
            timer = undefined;
        }, timeout);
    };
}


export function throttleAsync(func: (...args) => Promise<unknown>) {
    let timer;
    return async (...args) => {
        if (!timer) {
            timer = true;
            return func.apply(this, args).then(_ => {
                timer = false
                return _;
            });
        }
    };
}
